/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { ErrorMessage } from '../entities/ErrorMessage'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const errorMessageSchema = z.enum([
  'unknown error',
  'validation error',
  'user not found',
  'user refresh token cookie not found',
  'user refresh token expired',
  'user already exists',
  'verification code not found',
  'user request not active',
  'user deleted',
  'user request not found',
  'user role invalid',
  'user email already exists',
  'user already restored',
  'user already deleted',
  'user phone already exists',
  'user email or phone already exists',
  'company not found',
  'driver is active',
  'driver not found',
  'driver taxopark city mismatch',
  'user request not valid',
  'user request limit exceeded',
  'user request phone number restricted',
  'report period too long',
  'company statistic data not found',
  'driver statistic data not found',
  'driver data not found',
  'order data not found',
]) as unknown as ToZod<ErrorMessage>